// extracted by mini-css-extract-plugin
export default {"site-search__content":"w7Ubav"};